var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.value, width: "450" },
      on: {
        "click:outside": function($event) {
          return _vm.$emit("cancel")
        }
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v(" Confirm Dates ")]),
          _c("v-card-text", [
            _vm.pastDates.length > 0
              ? _c(
                  "div",
                  { staticClass: "mb-6" },
                  [
                    _c("p", [
                      _vm._v(
                        "- The following selected dates are before the current day:"
                      )
                    ]),
                    _vm._l(_vm.pastDates, function(obj) {
                      return _c(
                        "v-row",
                        { key: obj.label + obj.date, staticClass: "ml-2" },
                        [
                          _c(
                            "v-col",
                            { staticClass: "font-weight-bold red--text py-0" },
                            [_vm._v(" " + _vm._s(obj.label) + " ")]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "font-weight-bold red--text py-0" },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.formatDate(obj.date)) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm.tprDatesLessThanThreeWeeks
              ? _c(
                  "div",
                  { staticClass: "mb-6" },
                  [
                    _c("p", [
                      _vm._v("- TPR promotion is less than 3 weeks in length.")
                    ]),
                    _c(
                      "v-row",
                      { staticClass: "ml-2" },
                      [
                        _c(
                          "v-col",
                          { staticClass: "font-weight-bold red--text py-0" },
                          [
                            _vm._v(
                              " Start Date: " +
                                _vm._s(_vm.formatDate(_vm.tprStartDate)) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "v-col",
                          { staticClass: "font-weight-bold red--text py-0" },
                          [
                            _vm._v(
                              " End Date: " +
                                _vm._s(_vm.formatDate(_vm.tprEndDate)) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c("p", [_vm._v("Proceed?")])
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "grey darken-1", text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("cancel")
                    }
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(" Continue ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }